import React from "react";
import PropTypes from "prop-types";

import PrivateRoute from "../PrivateRoute";

function AccountRoute({ Component, path, ...rest }) {
  return (
    <PrivateRoute path={path}>
      <Component path={path} {...rest} />
    </PrivateRoute>
  );
}

AccountRoute.propTypes = {
  Component: PropTypes.any,
  path: PropTypes.string,
};

export default AccountRoute;
